import { useCallback, useEffect, useRef } from "react";
import { useAuraSupportInfo } from "src/Utils/Hooks/UseAuraInfoContext";
import { useDeleteTrialDemo } from "./useDeleteTrialDemo";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";

export const useDeleteClinicTrialDemoWrapper = () => {
    const {removeClinicLicense, requestResponse, requestError, requestLoading} = useDeleteTrialDemo();
    const { setInfobar, setLoader, reset } = useAuraSupportInfo();
    const clinicDetails = useRef<{
        entitlementId: string;
        distributorName: string;
        licenseType: string;
        distributorId: string;
    }>({ entitlementId: '', distributorName:'', licenseType: '', distributorId: '' });
    useEffect(() => {
        if (requestError !== '') {
            logger.logError(`Error occur while deleting trial or demo license ${requestError}. Entitlement Id is ${clinicDetails.current.entitlementId}.`);
            setInfobar({ message: requestError, messageType: InfoMessageType.error })
        }
    }, [requestError, setInfobar])
    useEffect(() => {
        if (requestResponse) {
            logger.logInformation(`Trial or demo license is deleted successfully. Entitlement is ${clinicDetails.current.entitlementId}.`);
            setInfobar({ message: `${clinicDetails.current.licenseType} license is deleted sucessfully from ${clinicDetails.current.distributorName}`, messageType: InfoMessageType.success })
        }
    }, [requestResponse, setInfobar])
    useEffect(() => {
        setLoader(requestLoading)
    }, [requestLoading, setLoader])

    const  deleteClinic= useCallback((entitlementId: string, distributorName: string, licenseType: string, distributorId: string) => {
        clinicDetails.current.entitlementId = entitlementId;
        clinicDetails.current.distributorName = distributorName;
        clinicDetails.current.licenseType = licenseType;
        clinicDetails.current.distributorId = distributorId;
        reset();
        console.log(`Request to delete ${licenseType} license with entitlement Id ${entitlementId} from ${distributorName} was made`);
        logger.logInformation(`Request to delete ${licenseType} license with entitlement Id ${entitlementId} from ${distributorName} was made`)
        removeClinicLicense(entitlementId, distributorId);
    },[removeClinicLicense, reset]) 

    return {requestResponse, requestError, deleteClinic}
}